// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"e47b4e97","346":"bcdced15","351":"7482c6c4","362":"fadd2285","431":"525edad2","458":"f57798e8","482":"f12ad2b1","528":"e4fc433a","587":"9ef50d44","608":"d73e47ab","613":"57dc78d9","707":"b392aa21","726":"e3d49107","730":"09a3eedb"}[chunkId] + ".chunk.js";
};